var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('NavHeader'),_c('NavHeaderMobile'),_c('div',{staticClass:"wrapper"},[_c('iframe',{attrs:{"frameborder":"0","src":`${_vm.baseUrl}/?widgetId=${_vm.widgetId}&tradeType=${_vm.tradeType}`}})]),_c('NewFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }